import { useLocation, Navigate } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'

import { apolloAuthData } from '../services/apollo'
import { deleteAuthData } from '../hooks/useAuth'

const RequireAuth = ({ children }) => {
  let location = useLocation()
  const auth = useReactiveVar(apolloAuthData)

  // if (!auth.signingIn && !auth.user) {
  if (!auth.authToken) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    deleteAuthData()

    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default RequireAuth
